"use client"

import { useEffect, useState } from "react"

import { USDT_PRICE } from "@/lib/live-data"

const MIN_RATE = 0.9995
const MAX_RATE = 1.001

function nextRate(previous: number): number {
  const delta = (Math.random() - 0.5) * 0.0003
  const value = Math.max(MIN_RATE, Math.min(MAX_RATE, previous + delta))
  return Number(value.toFixed(4))
}

export function useLiveUsdtPrice(refreshMs = 5000): number {
  const [rate, setRate] = useState(USDT_PRICE)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRate((previous) => nextRate(previous))
    }, refreshMs)

    return () => window.clearInterval(id)
  }, [refreshMs])

  return rate
}
